export default "__VITE_ASSET__fa41d289__"